import { VariantDeleteRequestApiV2Dto } from '@tiendanube/common';

export const getDeleteVariantPayload = (
  variantId: string,
): VariantDeleteRequestApiV2Dto => ({ id: Number(variantId), '@delete': true });
